import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormState } from 'react-final-form';
import {
  fetchAllAsync,
  selectConfigControl,
  selectTiposDocumentos,
} from '../../features/tipo-documento/tipoDocumentoSlice';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';
import { isAutoLoadControl } from '../../utils/store/store-utils';

export default function QCXSelectTipoDocumentoAutocomplete({
  id,
  key,
  label,
  name,
  filterParams,
  ...restProps
}) {
  const dispatch = useDispatch();

  const { values } = useFormState();

  const list = useSelector(selectTiposDocumentos);
  const configControl = useSelector(selectConfigControl);

  const [defaultValue, setDefaultValue] = useState('');

  useEffect(() => {
    const handleFetch = () => {
      if (isAutoLoadControl(configControl)) {
        dispatch(fetchAllAsync(filterParams));
      }
    };

    handleFetch();
  }, [configControl, filterParams]);

  useEffect(() => {
    const value = list.find((item) => (
      item?.id === _.get(values, name)
    ));

    if (value) {
      setDefaultValue(value);
    } else {
      setDefaultValue({ id: null, description: '' });
    }
  }, [list, values]);

  const filterOptions = createFilterOptions({
    stringify: (item) => `${item?.id} - ${item?.description}`,
  });

  return (
    <QCXAutocompleteSelect
      id={id}
      key={key}
      label={label}
      name={name}
      options={list}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={(item) => (
        item?.id && item?.description
          ? `${item?.id} - ${item?.description}`
          : ''
      )}
      {...restProps}
    />
  );
}
